<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="ded">I only wanted to be just a man fulfilled </p>
<p class="ded2">but a little more free</p>
<p class="ded2">A little more free, a little more free.</p>
<p class="chicago"><em class="itals">Chicago, “Flight 602”</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ALittleMoreFree_Text_Final-2.vue?3ba296f6